import {
  FaBriefcase,
  FaCalendarAlt,
  FaImages,
  FaRegNewspaper,
  FaPowerOff,
} from "react-icons/fa";
import { BsCollectionPlayFill } from "react-icons/bs";
import { TiMessages } from "react-icons/ti";
import { GrVmMaintenance } from "react-icons/gr";
import { MdEditSquare, MdDriveFileRenameOutline } from "react-icons/md";
import { IoFootsteps } from "react-icons/io5";
import { AiFillMessage } from "react-icons/ai";

import { Link, Form } from "react-router-dom";
import Wrapper from "../../assets/wrappers/Job";
import BuildingInfo from "./BuildingInfo";

import day from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
day.extend(advancedFormat);

const Building = ({
  _id,
  city,
  street,
  houseNumber,
  messages,
  buildingType,
  buildingOwner,
  rssTitleNewsPath,
  workOnSaturday,
  maintenanceCompany,
  createdAt,
  memberType,
  screenStatus,
  nickname,
}) => {
  const date = day(createdAt).format("DD.MM.YYYY");

  const handleFullScreen = (event) => {
    event.preventDefault(); // מונע מעבר מיידי לפני השמירה
    sessionStorage.setItem("goFullScreen", "true");
    window.location.href = `/public/${_id}`;
  };

  return (
    <Wrapper>
      <header>
        {}
        <div style={{ marginRight: "10px", height: "30px" }}>
          <Link to={`../edit-building/${_id}`} className="btn edit-btn">
            <MdEditSquare></MdEditSquare>
          </Link>
        </div>
        <div className="info">
          <h5>
            {city} , {street} {houseNumber}
          </h5>
          <p>{nickname}</p>
        </div>
      </header>
      <div className="content">
        <div className="content-center">
          <BuildingInfo
            icon={<FaPowerOff />}
            text={screenStatus}
            tooltip="מצב במסך"
          />

          <BuildingInfo
            icon={<FaCalendarAlt />}
            text={date}
            tooltip="תאריך יצירה"
          />

          <BuildingInfo
            icon={<FaRegNewspaper />}
            text={rssTitleNewsPath}
            tooltip="חדשות בתחתית המסך"
          />
          <BuildingInfo
            icon={<FaBriefcase />}
            text={workOnSaturday}
            tooltip="פעילות בשבת"
          />
          {maintenanceCompany && (
            <BuildingInfo
              icon={<GrVmMaintenance />}
              text={maintenanceCompany.name + " " + maintenanceCompany.lastName}
            />
          )}
        </div>
        <footer className="actions">
          {buildingType === "מגורים" && (
            <Link
              to={`../add-message/${_id}`}
              className="btn edit-btn"
              style={{ background: "#384B70" }}
            >
              <AiFillMessage />
            </Link>
          )}
          <Link
            to={`../add-media-building/${_id}`}
            className="btn edit-btn"
            style={{ background: "#5B6D5B" }}
            title="העלאת מדיה"
          >
            <FaImages />
          </Link>
          {buildingType === "מגורים" && (
            <Link
              onClick={handleFullScreen}
              style={{ background: "#B8001F", marginRight: "auto" }}
              to={`/public/${_id}`}
              className="btn edit-btn"
            >
              <BsCollectionPlayFill />
            </Link>
          )}
          {buildingType === "משרדים" && (
            <Link
              style={{ background: "#5E936C", marginRight: "auto" }}
              to={`../add-floor/${_id}`}
              className="btn edit-btn"
            >
              <IoFootsteps />
            </Link>
          )}
        </footer>
      </div>
    </Wrapper>
  );
};

export default Building;
